exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".linear-progress-bar {\n  background-color: #ccc;\n  position: fixed;\n  width: 100%;\n  z-index: 1;\n}\n.success div {\n  background-color: #8ebe2f;\n}\n.pending div {\n  background-color: #f3971f;\n}\n.rejected div {\n  background-color: #f04f23;\n}\n", ""]);
